@if(print && filter){
<app-print-filter-data [filter]="filter" />
}

<!-- Dados do Gráfico -->

@if (data) { @for (page of data.pages; track page.pageNumber) { @for (question
of page.questions; track $index) {

<div class="card">
  <p class="title">{{ question.title }}</p>
  <hr />
  <div class="count">
    <img src="assets/img/account_circle.png" alt="account_circle" />
    <p>{{ question.totalResponses }} respostas</p>
  </div>

  <div class="chart">
    @if (question.satisfactionPercentage) {
    <div class="satisfacao">
      <p>Satisfação</p>
      <h1>{{ question.satisfactionPercentage }}%</h1>
    </div>
    }
    <div class="bar-chart">
      <app-custom-bar-chart
        [dataType]="
          question.satisfactionPercentage
            ? chartColorsEnum.colorsWeight
            : chartColorsEnum.singleColor
        "
        [data]="question.answerDetail"
      />
    </div>
  </div>
</div>
} } @empty {
<div class="empty">
  <p>Não há dados para exibir</p>
</div>
} } @else {
<div class="empty">
  <p>Não há dados para exibir</p>
</div>
}
